const MONTH_NAMES_RU_CAP = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

const MONTH_NAME_IN_COMMENT_RE = /за\s+(январ|феврал|март|апрел|ма[йя]|июн|июл|август|сентябр|октябр|ноябр|декабр)/i;

export const normalizeBuhPaymentStatus = (status) => {
    const s = String(status || 'created').trim().toLowerCase();
    if (s === 'client_paid' || s === 'confirmed') return s;
    return 'created';
};

export const isBuhBillUnpaid = (pack) =>
    normalizeBuhPaymentStatus(pack?.payment_status) === 'created';

/** Красный или жёлтый основной счёт — как в блокировке сообщений/задач. */
export const isBuhBillUnpaidForSuspend = (pack) => {
    if (isExtraBuhBill(pack)) return false;
    const status = normalizeBuhPaymentStatus(pack?.payment_status);
    return status === 'created' || status === 'client_paid';
};

export const isExtraBuhBill = (pack) => {
    const comment = String(pack?.comment || '').trim().toLowerCase();
    return comment.includes('дополнительн');
};

const normalizeBuhBillCommentText = (comment) => {
    const c = String(comment || '').trim();
    if (!c) return '';
    return c.replace(/^Бух(\s+услуги)/i, 'Бухгалтерские$1');
};

const quarterLabelFromPeriodKey = (period) => {
    if (!period || !/^\d{4}-(0[1-9]|1[0-2])$/.test(period)) return null;
    const [year, monthStr] = period.split('-');
    const month = Number(monthStr);
    if (![1, 4, 7, 10].includes(month)) return null;
    const quarter = (month - 1) / 3 + 1;
    return `Бухгалтерские услуги за ${quarter} квартал ${year}`;
};

const periodKeyFromPack = (pack) => {
    if (pack?.statement_period && /^\d{4}-(0[1-9]|1[0-2])$/.test(pack.statement_period)) {
        return pack.statement_period;
    }
    if (pack?.created_at) {
        const d = new Date(pack.created_at);
        if (!Number.isNaN(d.getTime())) {
            const month = String(d.getMonth() + 1).padStart(2, '0');
            return `${d.getFullYear()}-${month}`;
        }
    }
    return '0000-00';
};

export const formatMainBuhBillLine = (pack) => {
    const comment = normalizeBuhBillCommentText(pack?.comment);
    const quarterMatch = comment.match(/за\s*(\d)\s*квартал\s*(\d{4})/i);
    if (quarterMatch) {
        return `Бухгалтерские услуги за ${quarterMatch[1]} квартал ${quarterMatch[2]}`;
    }

    const period = pack?.statement_period;
    if (period && /^\d{4}-(0[1-9]|1[0-2])$/.test(period)) {
        if (!MONTH_NAME_IN_COMMENT_RE.test(comment)) {
            const quarterLabel = quarterLabelFromPeriodKey(period);
            if (quarterLabel) return quarterLabel;
        }
        const [year, monthNum] = period.split('-');
        const monthIdx = Number(monthNum) - 1;
        const month = MONTH_NAMES_RU_CAP[monthIdx];
        if (month) {
            if (comment && /бухгалтерск/i.test(comment)) return comment;
            return `Бухгалтерские услуги за ${month} ${year}`;
        }
    }

    if (comment) return comment;
    return 'Бухгалтерские услуги';
};

export const buildBuhBillPaymentSummary = (packs) => {
    const list = Array.isArray(packs) ? packs : [];
    const unpaid = list.filter(isBuhBillUnpaid);
    const mainUnpaid = unpaid
        .filter((pack) => !isExtraBuhBill(pack))
        .sort((a, b) => periodKeyFromPack(a).localeCompare(periodKeyFromPack(b)));
    const extraUnpaid = unpaid.filter(isExtraBuhBill);

    const billLines = [];
    if (unpaid.length === 0) {
        billLines.push('Все оплачено');
    } else {
        mainUnpaid.forEach((pack) => billLines.push(formatMainBuhBillLine(pack)));
        if (extraUnpaid.length > 0) {
            billLines.push('Дополнительные бухгалтерские услуги');
        }
    }

    const mainUnpaidCount = mainUnpaid.length;
    const mainSuspendCount = list.filter(isBuhBillUnpaidForSuspend).length;
    const isSuspended = mainSuspendCount >= 2;
    const serviceStatus = isSuspended
        ? 'Обслуживание приостановлено'
        : 'Обслуживание ведется';

    return {
        billLines,
        serviceStatus,
        unpaidCount: mainUnpaidCount,
        isSuspended,
    };
};
